// extracted by mini-css-extract-plugin
module.exports = {"Editor":"Editor___2ROii"};